export default __webpack_public_path__ + "static/media/12.9af650dc.jpg";